import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ResetPasswordForm } from "../../components/auth";
import { useAuth } from "../../hooks";
import AuthLayout from "../../layouts/AuthLayout";

const ResetPasswordPage = () => {
  const { token } = useParams<{ token: string }>();
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // If user is already authenticated, redirect to home page
    if (isAuthenticated) {
      navigate("/", { replace: true });
    }

    // Validate token exists
    if (!token) {
      navigate("/auth/login", { replace: true });
    }
  }, [isAuthenticated, navigate, token]);

  return (
    <AuthLayout title="Reset Your Password">
      <ResetPasswordForm />
    </AuthLayout>
  );
};

export default ResetPasswordPage;
